// extracted by mini-css-extract-plugin
export default {"analyticsTogglerWrapper":"AnalyticsToggler_analyticsTogglerWrapper__y8G6+","option":"AnalyticsToggler_option__didtZ","selected":"AnalyticsToggler_selected__FS+yx"};